var angular = require('angular');
var template = require('./applicationSummaryIcon.pug');

 angular.module("app.directives").directive('applicationSummaryIcon', function () {
  return {
    restrict: 'E',
    scope: {
      application: "=",
    },

    template: template,
    link: function (scope) {


    }
  }


});
